/**
 * This tooltip is different than the pre-themed version that comes from
 * @radix-ui/themes. We use a custom tooltip on the app sidebar where we need
 * more control over the styling. It should only be used within the context of a
 * sidebar in its collapsed state.
 */

import {
  Tooltip as RadixTooltip,
  TooltipTrigger as RadixTooltipTrigger,
  TooltipContent as RadixTooltipContent,
  TooltipProvider as RadixTooltipProvider,
} from "@radix-ui/react-tooltip";
import cx from "classnames";
import { forwardRef } from "react";

export const TooltipProvider = RadixTooltipProvider;
export const Tooltip = RadixTooltip;
export const TooltipTrigger = RadixTooltipTrigger;

export const TooltipContent = forwardRef<
  React.ElementRef<typeof RadixTooltipContent>,
  React.ComponentPropsWithoutRef<typeof RadixTooltipContent>
>(function SidebarTooltipContent(props, ref) {
  const { className, ...rest } = props;
  return (
    <RadixTooltipContent
      ref={ref}
      className={cx(
        "group/menu-item-tooltip puntt-link z-50 overflow-hidden rounded-md bg-puntt-neutral-gray-4 px-3 py-2 shadow-md",
        className,
      )}
      {...rest}
    />
  );
});
